<div class="table-wrapper">
    <table>
        <tr>
            <th colspan="9">
                @if (showGroupHeader) {
                    <sew-skeleton class="group-header"></sew-skeleton>
                }
                <sew-skeleton class="table-header"></sew-skeleton>
            </th>
        </tr>
        @for (row of rows; track row) {
            <tr>
                <td>
                    <sew-skeleton class="checkbox"></sew-skeleton>
                </td>
                <td>
                    <sew-skeleton class="picture"></sew-skeleton>
                </td>
                <td>
                    <sew-skeleton class="article-name"></sew-skeleton>
                    <sew-skeleton class="article-number"></sew-skeleton>
                </td>
                <td>
                    <sew-skeleton class="part-number"></sew-skeleton>
                </td>
                <td>
                    <sew-skeleton class="wear"></sew-skeleton>
                </td>
                <td class="quantity-underline">
                    <div class="quantity-wrapper">
                        <sew-skeleton class="reset-quantity"></sew-skeleton>
                        <sew-skeleton class="quantity"></sew-skeleton>
                    </div>
                </td>
                <td>
                    <sew-skeleton class="availability-top"></sew-skeleton>
                    <sew-skeleton class="availability-bottom"></sew-skeleton>
                </td>
                <td>
                    <sew-skeleton class="add-to-cart"></sew-skeleton>
                </td>
            </tr>
        }
    </table>
</div>
<div class="action-bar">
    <sew-skeleton class="action-bar-button"></sew-skeleton>
</div>
